
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,

    report_stock
} from "../../../components/CustomComponent.js";

import { exportToExcel, exportToPDF } from "../ExportFunctions";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_create: false,
            modal_delete: false,
            modal_update: false,
            excel_active: false,


            loading: false,
            data: [],
            dataAll: [],
            data_category: [],

            tab: 1,

            picture: "",
            data_search: "",
            category_id: ""

        }
        this.tableRef = React.createRef();
    }
    async componentDidMount() {
        this.GetCategory();
        this.GetAllStock();
    }
    Get = async () => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: this.state.data_search,
            warehouse_id: ""
        }
        if(this.state.category_id != ''){
            body["category_id"] = this.state.category_id
        }
        let result = await GET(tokens, "v1/TH/stock-manage/balance/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result.data);
            this.setState({ data: result.data });
        }
        this.setState({ loading: false });
    } 
    GetAllStock = async () => {
        let resultall = await GET(tokens, "v1/TH/stock-manage/balance_all/");
        if (resultall && resultall.status) {
            console.log(resultall.data);
            this.setState({ dataAll: resultall.data, excel_active: true });
        }
    } 
    GetCategory = async () => {
        this.setState({ loading: true });
        let result = await GET(tokens, "v1/TH/product-manage/product-category/list/" + getStorage("branch").branch_id,);
        if (result && result.status) {
            this.setState({ data_category: result.data });
            if(result.data.length > 0){
                this.setState({ category_id: result.data[0]['category_id'] });
                await this.Get()
            }
        }
        this.setState({ loading: false });
    }
    handleExcelExport = () => {
        const success = exportToExcel(this.state.dataAll, "รายงานสต๊อกคงคลัง");
        if (success) {
            alert("ส่งออกไฟล์ Excel สำเร็จ");
        } else {
            alert("เกิดข้อผิดพลาดในการส่งออกไฟล์ Excel");
        }
    }
    handlePDFExport = () => {
        const branchInfo = getStorage("branch");
        const success = exportToPDF(this.state.data, branchInfo, "รายงานสต๊อกคงคลัง");
        if (success) {
            alert("ส่งออกไฟล์ PDF สำเร็จ");
        } else {
            alert("เกิดข้อผิดพลาดในการส่งออกไฟล์ PDF");
        }
    }

    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="แดชบอร์ด" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>รายงานสต๊อกคงคลัง</b></h3>
                            <div className="d-flex">
                                <button className="btn btn-orange mx-1" onClick={this.handlePDFExport}>
                                    พิมพ์รายงาน (PDF)
                                </button>

                                <button type="button" disabled={!this.state.excel_active} className="btn btn-dark px-4 mx-1 mb-2" onClick={this.handleExcelExport}>
                                    EXCEL
                                </button>
                            </div>
                        </div>
                        <div className="w-100 card border-0 p-0">
                            <div className="d-flex flex-wrap mx-0 px-3 pt-3">
                                <input
                                    className="form-control wpx-250 bg-contain border-0 mx-1 mb-2"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ data_search: e.target.value }) }}
                                    onKeyUp={(e) => {
                                        if (e.key === "Enter") {
                                            this.setState({ page: 1 });
                                            setTimeout(() => {
                                                this.Get();
                                            }, 10);
                                        }
                                    }}
                                    value={this.state.data_search}
                                />
                                <select className="form-control wpx-250 bg-contain border-0 mx-1 mb-2"
                                    onChange={(e) => {
                                        this.setState({ category_id: e.target.value, page: 1 })
                                        setTimeout(() => {
                                            this.Get();
                                        }, 10);
                                    }}
                                    value={this.state.category_id}>
                                    <option value="">หมวดหมู่</option>
                                    { this.state.data_category.map((item, index) => (
                                        <option value={item.category_id}>{item.category_name}</option>
                                    ))}
                                </select>
                                <button className="btn btn-orange mx-1 mb-2" onClick={() => {
                                    this.setState({ page: 1 });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    ค้นหา
                                </button>
                                <button className="btn btn-outline-orange mx-1 mb-2" onClick={() => {
                                    this.setState({ page: 1, data_search: "" });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    รีเซ็ต
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-borderless table-striped" ref={this.tableRef}>
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="text-left text-white" style={{width: '140px'}}>รหัสสินค้า</th>
                                            <th className="text-center text-white" style={{width: '440px'}}>ชื่อสินค้า</th>
                                            <th className="text-center text-white" style={{width: '120px'}}>Serial Number</th>
                                            <th className="text-center text-white">หมวดหมู่</th>
                                            <th className="text-center text-white">คลังสินค้า</th>
                                            <th className="text-center text-white">จำนวนคงเหลือ</th>
                                        </tr>
                                    </thead>

                                    {this.state.data && this.state.data.map((product, product_index) => (
                                        <tbody>
                                            <tr  className={product_index %2 ? "bg-primary-light" : null }>
                                                <td className="text-left" >{product.product_code ? product.product_code : "-"}</td>
                                            
                                                <td className="text-left" >{product.product_name ? product.product_name : "-"}</td>
                                                <td className="text-left">
                                                    {product.product_serial && product.product_serial.length > 0 ? (
                                                        product.product_serial.map((item, index) => (
                                                            <p key={index}>{item}</p>
                                                        ))
                                                    ) : (
                                                    <p>-</p>
                                                    )}
                                                </td>
                                            
                                                <td className="text-center" >{product.product_category ? product.product_category : "-"}</td>
                                                {/* {product.data.map((item, index) => ( */}
                                                <td className="text-left">{product.data[0].warehouse_data }</td>
                                                <td className="text-center">{product.data[0].quantity }</td>
                                                {/* ))} */}
                                            </tr>
                                        </tbody>
                                    ))}
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}
